export default "__VITE_ASSET__C8UK5iTs__"